<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="120px">

    <el-form-item label="印章名称" prop="fName">
      <el-input v-model="form.fName" />
    </el-form-item>
    <el-form-item label="顺序号" prop="fSqe">
      <el-input-currency v-model="form.fSqe" :scale="0" size="small" :min="null" />
    </el-form-item>
    <el-form-item label="印章图片" prop="pictureUrl">
      <template v-if="form.pictureUrl">
        <img width="100" height="100" :src="form.pictureUrl">
        <el-button size="small" type="text" style="margin-left:10px" @click="_import">更换</el-button>
      </template>
      <template v-else>
        <el-button size="small" icon="el-icon-plus" circle @click="_import" />
      </template>
      <input ref="fileSel" type="file" style="display:none;" accept="image/jpeg, image/jpg, image/png">
    </el-form-item>

  </el-form>

</template>

<script>
export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        fName: [{ required: true, message: '必填项', trigger: 'change' }],
        fDes: [{ required: true, message: '必填项', trigger: 'change' }]
      }
    }
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = Object.assign({}, this.form)
          onValid(data)
        } else {
          return false
        }
      })
    },
    _import: function() {
      const _this = this
      var fileSel = this.$refs.fileSel
      fileSel.onchange = () => {
        setTimeout(() => {
          fileSel.value = null
        }, 100)
        if (!fileSel.files.length) return
        var file = fileSel.files[0]
        _this.imgFile = file

        var reader = new FileReader()
        reader.onload = function(e) {
          _this.imgSrc = e.target.result
        }
        reader.readAsDataURL(file)
      }
      fileSel.click()
    }
  }
}
</script>

<style>

</style>
